"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
const table_style_1 = require("../../components/table/table.style");
const theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-FormList',
    loading: 'c-FormList--loading',
    tableCell: 'c-FormList__TableCell',
    tableCellButton: 'c-FormList__TableCellButton',
    tableCellFaint: 'c-FormList__TableCell--faint',
    tableCellMenu: 'c-FormList__TableCell--menu',
};
exports.Style = {
    [exports.CSS.container]: {
        [`& .${table_style_1.CSS.container}`]: {
            width: '80%',
            'margin-bottom': theme_1.DefaultTheme.space(6),
        },
        [`& .${table_style_1.CSS.header} > th:last-of-type`]: {
            width: '100px',
        },
        [`& .${table_style_1.CSS.cell}:last-of-type`]: {
            overflow: 'visible',
        },
        [`& .${table_style_1.CSS.header} > th:nth-of-type(4), & .${table_style_1.CSS.header} > th:nth-of-type(5)`]: {
            width: '220px',
        },
    },
    [exports.CSS.loading]: {
        display: 'flex',
        'justify-content': 'center',
        padding: theme_1.DefaultTheme.space(4),
    },
    [exports.CSS.tableCell]: {
        'text-overflow': 'ellipsis',
        overflow: 'hidden',
        'white-space': 'nowrap',
    },
    [exports.CSS.tableCellButton]: {
        padding: `0 ${theme_1.DefaultTheme.space(1)}`,
        'text-align': 'left',
    },
    [exports.CSS.tableCellFaint]: {
        color: theme_1.DefaultTheme.font.color.supporting,
    },
    [exports.CSS.tableCellMenu]: {
        display: 'flex',
        'justify-content': 'flex-end',
        overflow: 'visible',
    },
};
//# sourceMappingURL=form.list.style.js.map